import { Actions, SortHeader, User } from '~/components/data-table/-components'

export default defineNuxtPlugin(() => {
  const nuxtApp = useNuxtApp()
  nuxtApp.vueApp.component('Actions', Actions)
  nuxtApp.vueApp.component('SortHeader', SortHeader)
  nuxtApp.vueApp.component('DataTableActions', Actions)
  nuxtApp.vueApp.component('DataTableUser', User)
})
